import { render, staticRenderFns } from "./CnicFront.vue?vue&type=template&id=1da4067e&"
import script from "./CnicFront.vue?vue&type=script&lang=js&"
export * from "./CnicFront.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports